import { render } from "./Quests.vue?vue&type=template&id=2639f79c"
import script from "./Quests.vue?vue&type=script&lang=js"
export * from "./Quests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__